import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6dc57e43")

_pushScopeId("data-v-6dc57e43")
const _hoisted_1 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_2 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = { class: "p-d-flex p-flex-row" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Message = _resolveComponent("Message")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.knParameterSavedParametersDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.main.savedParameters')), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_Button, {
            id: "saved-parameters-dialog-close-button",
            class: "kn-button kn-button--primary",
            onClick: _ctx.closeDialog
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.viewpoints,
        class: "p-datatable-sm kn-table",
        paginator: _ctx.viewpoints.length > 20,
        dataKey: "id",
        filters: _ctx.filters,
        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
        globalFilterFields: _ctx.knParameterSavedParametersDialogDescriptor.globalFilterFields,
        responsiveLayout: "stack",
        breakpoint: "600px"
      }, {
        header: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                placeholder: _ctx.$t('common.search')
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ])
        ]),
        empty: _withId(() => [
          _createVNode(_component_Message, {
            class: "p-m-2",
            severity: "info",
            closable: false,
            style: _ctx.knParameterSavedParametersDialogDescriptor.styles.message
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.knParameterSavedParametersDialogDescriptor.columns, (col) => {
            return (_openBlock(), _createBlock(_component_Column, {
              class: "kn-truncated",
              field: col.field,
              header: _ctx.$t(col.header),
              key: col.field,
              sortable: true
            }, null, 8, ["field", "header"]))
          }), 128)),
          _createVNode(_component_Column, {
            style: _ctx.knParameterSavedParametersDialogDescriptor.iconColumn.style
          }, {
            body: _withId((slotProps) => [
              _createVNode("div", _hoisted_4, [
                _withDirectives(_createVNode(_component_Button, {
                  icon: "fas fa-file-signature",
                  class: "p-button-link p-mr-2",
                  onClick: _withModifiers(($event: any) => (_ctx.$emit('fillForm', slotProps.data)), ["stop"])
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    _ctx.$t('documentExecution.main.fillForm'),
                    void 0,
                    { left: true }
                  ]
                ]),
                _withDirectives(_createVNode(_component_Button, {
                  icon: "fa fa-play-circle",
                  class: "p-button-link p-mr-2",
                  onClick: _withModifiers(($event: any) => (_ctx.$emit('executeViewpoint', slotProps.data)), ["stop"])
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    _ctx.$t('common.execute'),
                    void 0,
                    { left: true }
                  ]
                ]),
                _withDirectives(_createVNode(_component_Button, {
                  icon: "fas fa-trash-alt",
                  class: "p-button-link",
                  onClick: _withModifiers(($event: any) => (_ctx.deleteViewpointConfirm(slotProps.data)), ["stop"])
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    _ctx.$t('common.delete'),
                    void 0,
                    { left: true }
                  ]
                ])
              ])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["value", "paginator", "filters", "globalFilterFields"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
})